import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BarChartIcon, Buildings2Icon, CogIcon, FileTextIcon, PersonGroupIcon } from '@navikt/aksel-icons';
import { Routes } from '../../enums/Routes';
import { useGetOrganizationQuery } from '../../hooks/queries/useGetOrganizationQuery';
import { getInitials } from '../../utils/getInitials';
import { PageBreadcrumb, TabbedPageLayout } from '../TabbedPageLayout';

const tabs = [
  { key: 'business', to: Routes.OrganizationBusiness, icon: Buildings2Icon },
  { key: 'settings', to: Routes.OrganizationSettings, icon: CogIcon },
  { key: 'users', to: Routes.OrganizationUsersOverviewPage, icon: PersonGroupIcon },
  { key: 'subscription', to: Routes.OrganizationSubscriptions, icon: FileTextIcon },
  { key: 'usage', to: Routes.OrganizationUsage, icon: BarChartIcon },
] as const;

export type OrganizationBreadcrumb = PageBreadcrumb;

type OrganizationLayoutProps = {
  /** Stien til en underside, for eksempel Brukere / e-post. Siste ledd er siden du står på. */
  breadcrumbs?: OrganizationBreadcrumb[];
  children: ReactNode;
};

/** Felles topp for organisasjonssidene: navnet på organisasjonen og fanene */
export const OrganizationLayout = ({ breadcrumbs, children }: OrganizationLayoutProps) => {
  const { t } = useTranslation();
  const { data: organization, isLoading } = useGetOrganizationQuery();

  return (
    <TabbedPageLayout
      initials={organization?.name ? getInitials(organization.name) : ''}
      eyebrow={t('organizationPage.eyebrow')}
      title={organization?.name ?? t('organizationPage.eyebrow')}
      isLoading={isLoading}
      tabs={tabs.map((tab) => ({ ...tab, label: t(`organizationPage.tabs.${tab.key}`) }))}
      tabsLabel={t('organizationPage.tabsLabel')}
      breadcrumbs={breadcrumbs}
    >
      {children}
    </TabbedPageLayout>
  );
};
